import { Box } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Dialog from '@mui/material/Dialog';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import AppHeader from '/@/components/app-header';
import Catalog from '/@/components/new-login/catalog';
import Container from '/@/components/new-login/container';
import Login from '/@/components/new-login/login';
import NewUser from '/@/components/new-login/new-user';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import { setCountry as setCountryAction } from '/@/store/session/actions';
import { getSessionCountries } from '/@/store/session/selectors';
import { mpTrackEvent } from '/@/store/tracking/mixpanel-events';
import useIsMobile from '/@/utils/hooks/is-mobile';
import LTBanner from '/@/views/users/new-login/assets/LTBanner.jpg';
import PasswordResetRequest from '/@/views/users/password-reset/request.js';
import styles from './styles.module.css';

const NewLogin = () => {
    const [catalog, setCatalog] = useState(false);
    const [anchorEl, setAnchorEl] = React.useState(false);
    const dispatch = useDispatch();
    const [newUser, setNewUser] = useState(false);
    const [passwordView, setPasswordView] = useState(false);
    const [finish, setFinish] = useState(false);
    const [login, setLogin] = useState(false);
    const [welcomeView, setWelcomeView] = useState(true);
    const [forgotPassword, setForgotPassword] = useState(false);
    const countries = useSelector(getSessionCountries);
    const setCountry = bindActionCreators(setCountryAction, dispatch);
    const isMobile = useIsMobile();

    useEffect(() => {
        const savedCountry = JSON.parse(localStorage.getItem('country-setted'));
        if (!savedCountry) {
            setAnchorEl(true);
        }
    }, []);

    const handleCloseNotification = (id) => {
        setCountry({ country: id });
        setAnchorEl(null);
    };

    const handleOnCatalogClick = () => {
        setCatalog(!catalog);
        setNewUser(false);
        setPasswordView(false);
        setFinish(false);
        setForgotPassword(false);
        setWelcomeView(false);
        if (isMobile) {
            setLogin(false);
        }
    };

    const handleOnCatalogGoBackClick = () => {
        setWelcomeView(true);
        setCatalog(false);
    };

    const handleNewUserClick = () => {
        setNewUser(!newUser);
        setCatalog(false);
        if (isMobile) {
            setLogin(false);
        }
    };

    const goBack = () => {
        setPasswordView(false);
        setNewUser(true);
    };

    const goBackToPassword = () => {
        if (!passwordView) {
            setPasswordView(true);
        } else {
            goBack();
        }
    };

    const handleGoBackToLogin = () => {
        setNewUser(false);
        setCatalog(false);
        setLogin(true);
        setWelcomeView(false);
    };

    const handleOnNextClick = () => {
        setPasswordView(!passwordView);
    };

    const handleForgotPassword = () => {
        mpTrackEvent('Forgot Password began', undefined);
        setForgotPassword(true);
        setWelcomeView(false);
        setLogin(false);
    };

    const handleHideReset = () => {
        setForgotPassword(false);
        if (isMobile) {
            setLogin(true);
        }
    };

    const handleGoToLogin = () => {
        if (isMobile) {
            setLogin(true);
            setWelcomeView(false);
        }
    };

    const goBackToWelcome = () => {
        setLogin(false);
        setWelcomeView(true);
    };

    const renderLogin = () => {
        return (
            <div className={styles.form}>
                {!catalog && !newUser && !forgotPassword && (
                    <Login onClick={handleNewUserClick} handleForgotPassword={handleForgotPassword} />
                )}
                {catalog && <Catalog onClick={handleOnCatalogClick} />}
                {forgotPassword && <PasswordResetRequest onClick={handleHideReset} />}
                {newUser && !finish && (
                    <NewUser
                        onClick={handleNewUserClick}
                        nextBtn={handleOnNextClick}
                        login={newUser}
                        password={passwordView}
                        goBack={goBack}
                        goBackToPassword={goBackToPassword}
                    />
                )}
            </div>
        );
    };
    const enableWelcomeView = (welcomeView && isMobile) || !isMobile;
    const headerEnabled = isMobile && !catalog && !login && !newUser && !forgotPassword;
    const enableLanguage = !catalog && !newUser && !forgotPassword;
    const open = Boolean(anchorEl && countries.length > 1);
    return (
        <div>
            {headerEnabled && <AppHeader hideBackButton login />}
            <Dialog
                open={settings.app.theme === 'latijereta'}
                onClose={(_, reason) => {
                    if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
                        return;
                    }
                }}
                disableEscapeKeyDown
            >
                <a href='https://www.agro.bayer.com.ar/la-tijereta'>
                    <img
                        src={LTBanner}
                        alt='la-tijereta-banner'
                        style={{
                            width: !isMobile ? '50vw' : '80vw',
                            maxWidth: 600,
                            cursor: 'pointer',
                            display: 'block',
                        }}
                    />
                </a>
            </Dialog>
            {enableWelcomeView && (
                <Container
                    handleGoToLogin={handleGoToLogin}
                    showCatalog={handleOnCatalogClick}
                    showLanguage={enableLanguage}
                >
                    {!isMobile && renderLogin()}
                </Container>
            )}
            {isMobile && login && (
                <Login
                    handleForgotPassword={handleForgotPassword}
                    goToCatalog={handleOnCatalogClick}
                    onClick={handleNewUserClick}
                    goBack={goBackToWelcome}
                />
            )}
            {isMobile && catalog && (
                <div className={headerEnabled && styles.headerStyles}>
                    <Catalog onClick={handleOnCatalogGoBackClick} />
                </div>
            )}

            {isMobile && forgotPassword && <PasswordResetRequest onClick={handleHideReset} />}

            {newUser && isMobile && (
                <NewUser
                    onClick={handleGoBackToLogin}
                    nextBtn={handleOnNextClick}
                    login={newUser}
                    password={passwordView}
                    goBack={goBack}
                />
            )}

            <Modal
                aria-labelledby='transition-modal-title'
                aria-describedby='transition-modal-description'
                open={open}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        maxWidth: { xs: 300, sm: 400 },
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: { xs: 2, sm: 2 },
                    }}
                >
                    <Typography id='transition-modal-description' sx={{ mx: { sm: 2 }, my: 2 }}>
                        {_('Por favor, seleccione su país para continuar:')}
                    </Typography>
                    <Box sx={{ m: { sm: 2 }, pb: { xs: 2, sm: 0 } }}>
                        <div
                            style={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gap: 15,
                            }}
                        >
                            {countries.map((c) => {
                                return (
                                    <div
                                        style={{
                                            display: 'flex',
                                            justifyContent: 'start',
                                            alignItems: 'center',
                                            padding: 10,
                                            gap: 10,
                                            cursor: 'pointer',
                                        }}
                                        className={styles.country}
                                        onClick={() => handleCloseNotification(c.id)}
                                    >
                                        <div className={classNames(styles.flag, styles[c.code])} />
                                        <div>{c.name}</div>
                                    </div>
                                );
                            })}
                        </div>
                    </Box>
                </Box>
            </Modal>
        </div>
    );
};

export default NewLogin;
